/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ErrandTable from './errand-table/errand-table';
import RegisteredOrders from '../../components/registered-orders/registered-orders';
import Benefit from './benefit/benefit';
import Translate from 'react-translate-component';
import CalculatorContainer from './calculator/calculator-container';
import PhoneNumberModal from '../../components/phone-number-modal/phone-number-modal';
import Ambassador from '../../components/left-page-section/ambassador/ambassador';
import BetaBanner from '../../components/beta-banner/beta-banner';
import InfoBanner from '../../components/info-banner/info-banner';
import ActivityDashboardButtonContainer from '../../components/dashboard-buttons/dashboard-button-container';
import ActivityDashboardWelcomeMessage from './welcome-message/activity-dashboard-welcome-message';
import { setShowFooter, setShowHeader } from '../../redux/modules/topBottomSection/index';
import AffectedItpOneModal from '../../components/modal/affected-itp-one-modal';
import AffectedItpTwoModal from '../../components/modal/affected-itp-two-modal';
import moment from 'moment';
import CookieUtils from 'frilans-finans/utils/cookie-utils';

class ActivitiesView extends React.Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    setShowFooter: PropTypes.func,
    setShowHeader: PropTypes.func,
    user: PropTypes.object
  };

  missingPhoneNumber () {
    const {user} = this.props;

    return (!CookieUtils.getHidePhoneNumberModalCookie() &&
      (user.hasOwnProperty('cellphone') &&
      !user.cellphone &&
      user.createdAt < moment('20221014').format())
    );
  }

  componentDidMount () {
    this.props.setShowFooter();
    this.props.setShowHeader();
  }

  renderRegisteredOrders () {
    return this.props.user && this.props.user.id
      ? (<RegisteredOrders
        user={this.props.user}
      />)
      : null;
  }

  renderErrandTable () {
    return this.props.user && this.props.user.id
      ? <ErrandTable/>
      : null;
  }

  render () {
    return (
      <div className='activities'>
        <BetaBanner />
        <InfoBanner />
        <div className='dashboard-welcome-container'>
          <ActivityDashboardWelcomeMessage
            username={this.props.user.firstName}
          />
          <ActivityDashboardButtonContainer />
        </div>
        {this.renderRegisteredOrders()}
        {this.renderErrandTable()}

        <div className='invoice-chart-wrapper'>
          <div className="row mb35">
            <div className='col-md-5 mb35'>
              <h2><Translate content='POINTS_AND_SAVINGS'/></h2>
              <Benefit type='bonus' user={this.props.user} />
              <Benefit type='vacation' user={this.props.user} />
              <Benefit type='pension' user={this.props.user} />
              <CalculatorContainer />
            </div>
            <Ambassador />
          </div>
        </div>
        <PhoneNumberModal
          modalIsOpen={this.missingPhoneNumber()}
        />
        <AffectedItpOneModal user={this.props.user} />
        <AffectedItpTwoModal user={this.props.user} />
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    footerState: state.topBottomSectionState.showFooter,
    headerState: state.topBottomSectionState.showHeader,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShowFooter: () => dispatch(setShowFooter()),
    setShowHeader: () => dispatch(setShowHeader())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesView);



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/activities-view.js
 **/